import Cookies from "js-cookie";
import {
  getLanguage
} from "@/locales/index";
const state = {
  sidebar: {
    opened: Cookies.get("sidebarStatus") ? !!+Cookies.get("sidebarStatus") : true,
    withoutAnimation: false,
  },
  device: "desktop",
  language: getLanguage(),
  searchData: {
    id: 0
  },
};
const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set("sidebarStatus", 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    Cookies.set("language", language);
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  setSearchData(state, value) {
    state.searchData = value;
  },
};
const actions = {
  toggleSideBar({
    commit
  }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({
    commit
  }, {
    withoutAnimation
  }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  setLanguage({
    commit
  }, language) {
    commit("SET_LANGUAGE", language);
  },
  toggleDevice({
    commit
  }, device) {
    commit("TOGGLE_DEVICE", device);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};